export const AUTH_SUCCESS = 'auth_success';
export const AUTH_FAIL = 'auth_fail';
export const AUTH_PENDING = 'auth_pending';
export const AUTH_LOGOUT = 'auth_logout';
export const AUTH_SET_USER = 'auth/SET_TOKEN';
